import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function Logout() {
  const navigate = useNavigate();
  const { logout } = useAuth(); // 👈 use the context logout

  const handleLogout = () => {
    logout();              // clears user + localStorage
    navigate("/login");    // redirect to login
  };

  return (
    <button onClick={handleLogout} className="logout-button">
      Logout
    </button>
  );
}
